module.exports = __webpack_public_path__ + "img/perforaciones_16-9_1440.0781a4f8.webp";